export interface IApiKey {
    id: string;
    name: string;
    enabled: boolean;
    keyType: string;
    username: string;
    // The API sends an ISO string (it is JSON); typed as Date, a real Date got into the cache and crashed the
    // details dialog, which renders it as text (AC-WEB-3A).
    createDate: string;
}

export interface IGetApiKeysResponse {
    keys: IApiKey[];
}

export interface IGenerateApiKeyRequest {
    name: string;
    keyType: string;
}

export interface IGetEmbeddedSessionKeyRequest{
    username: string;
    password: string;
    context: string;
}

export interface IResolveEmbeddedSessionRequest{
    sessionResolverToken: string;
    username: string;
    context: string;
}

export interface IGenerateApiKeyResponse {
    id?: string;
    key?: string;
    error?: string;
    success: boolean;
}

export interface IGetSessionKeyRequest {
    organization: string;
    key: string;
}

export interface IKeyAuthTypesResponse {
    keyTypes: {[key: string]: string};
}
/** Mirrors the API's SupportLoginExchangeRequest (V_7.0 Settings). */
export interface ISupportLoginExchangeRequest {
    code: string;
}

/** Mirrors the API's SupportLoginExchangeResponse (V_7.0 Settings). */
export interface ISupportLoginExchangeResponse {
    sessionKey: string;
    sessionId: string;
    expiresAt: string;
    organization: string;
    organizationName?: string;
    username: string;
    actor: string;
    actorName?: string;
}

/** Mirrors the API's SupportSessionStatusResponse (V_7.0 Settings). */
export interface ISupportSessionStatus {
    sessionId: string;
    expiresAt: string;
}

/** Mirrors the API's SupportSessionNotesResponse (V_7.0 Settings). */
export interface ISupportSessionNotes {
    text: string;
    /** When they were last saved; absent while the session has no notes. */
    updatedAt?: string;
}

/** Mirrors the API's SupportSessions.MAX_NOTES_LENGTH. */
export const SUPPORT_NOTES_MAX_LENGTH = 20000;
